import { useState } from 'react';

import { StoreSwitcherSkeleton } from '@jane/bloom/components/skeletonLoaders/storeSwitcherSkeleton';
import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { useUserSearchQuery } from '@jane/bloom/hooks/useUserSearchQuery';
import { trackStoreSet } from '@jane/bloom/services/tracking/track';

import styles from './nearbyStores.module.css';
import { StoreCard } from './storeCard';

export function NearbyStores() {
  const {
    availableStores,
    busy,
    fulfillmentMode,
    setPinnedStore,
    validationState,
  } = useStoreSwitcher();
  const { featureFlags, pinnedStore } = useRootLoaderData();
  const [selectedStoreId, setSelectedStoreId] = useState<number>(
    pinnedStore.id
  );

  const { setSearchModalQuery, setSearchResultsQuery } = useUserSearchQuery();

  const onStoreSelection = (storeId: number, storeListIndex: number) => {
    setSearchModalQuery('');
    setSearchResultsQuery('');
    setSelectedStoreId(storeId);
    setPinnedStore(storeId);
    trackStoreSet(storeListIndex, featureFlags);
  };

  const pinnedStoreMatchesCriteria =
    availableStores.length &&
    availableStores.find((store) => store.id === pinnedStore.id) &&
    (fulfillmentMode === 'both' ||
      (fulfillmentMode === 'rec' && pinnedStore.recreational) ||
      (fulfillmentMode === 'med' && !pinnedStore.recreational));

  return (
    <div className={styles['nearbyStores']}>
      {validationState === 'idle' && !busy ? (
        <div className={styles['storesRow']}>
          {pinnedStoreMatchesCriteria ? (
            <StoreCard
              store={pinnedStore}
              selected={pinnedStore.id === selectedStoreId}
              selectStore={() => onStoreSelection(pinnedStore.id, 0)}
            />
          ) : null}

          {availableStores
            .filter((store) => store.id !== pinnedStore.id)
            .map((store, i) => {
              const storeListIndex = i + 1; // +1 to account for the pinned store at index 0
              return (
                <StoreCard
                  key={store.id}
                  store={store}
                  selected={store.id === selectedStoreId}
                  selectStore={() => onStoreSelection(store.id, storeListIndex)}
                />
              );
            })}
        </div>
      ) : (
        <StoreSwitcherSkeleton />
      )}
    </div>
  );
}
